import React from 'react';
import SmoothScroll from "smooth-scroll";
import Navbar from './commons/navbar';
import Footer from './commons/footers';
import ScrollToTop from './commons/ScrollToTop';

export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

const AppLayout = ({children}) => {
    return (
        <div>
            <Navbar />
                {children}
            <Footer />
            <ScrollToTop />
        </div>
    );
}

export default AppLayout;